import * as angular from "angular";
import {BreakType} from "../models/break-type.model";
import {EnforceMinimumBreakEnum} from "../types/enforce-minimum-break.enum";

export class BreakTypesDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  createBreakType(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-break-type-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Create Break';
        $scope.action = 'Submit';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.breakType = <Partial<BreakType>>{
          name: 'Break',
          description: undefined,
          paid: false,
          autoBackFromBreak: false,
          durationMinutes: 30,
          backFromBreakReminderGapMinutes: 5,
          enforceMinimumBreakType: EnforceMinimumBreakEnum.NONE
        };

        $scope.enforceMinimumBreakTypes = Object.values(EnforceMinimumBreakEnum);
        $scope.onEnforceMinimumBreakTypeChange = (value) => {
          $scope.breakType.enforceMinimumBreakType = value;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.breakType);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editBreakType(event, breakType: BreakType) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-break-type-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Break';
        $scope.action = 'Submit';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.breakType = breakType;

        $scope.enforceMinimumBreakTypes = Object.values(EnforceMinimumBreakEnum);
        $scope.onEnforceMinimumBreakTypeChange = (value) => {
          $scope.breakType.enforceMinimumBreakType = value;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.breakType);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('breakTypesDialogsService', BreakTypesDialogsService);
